import React from 'react';
import { processEmojisInText } from './emojiUtils';

// Função para detectar e converter URLs em links clicáveis e texto em negrito
export const renderTextWithLinks = (text: string, isDashboard?: boolean, tipo?: string, remetenteTipo?: string) => {
  if (!text) return null;

  // Process emojis first to ensure consistent rendering
  const processedText = processEmojisInText(text);

  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const boldRegex = /\*([^*]+)\*/g;

  // Primeiro dividimos por URLs
  const parts = processedText.split(urlRegex);

  const nodes: React.ReactNode[] = parts.map((part, index) => {
    // Se for uma URL
    if (part.match(urlRegex)) {
      // No Dashboard, exibimos apenas o texto "Link da Web" para evitar conteúdos extensos e garantir que nunca apareça [object Object]
      if (isDashboard) {
        return "Link da Web";
      }
      return (
        <a
          key={`url-${index}`}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 dark:text-blue-400 hover:underline break-all"
        >
          {part}
        </a>
      );
    }

    // Processa o texto para negrito
    let lastIndex = 0;
    const result: Array<string | React.ReactNode> = [];
    let match;
    let keyCounter = 0;
    // Recria o regex para evitar compartilhamento de estado (lastIndex) entre partes
    const localBoldRegex = /\*([^*]+)\*/g;

    // Encontra todas as ocorrências de texto em negrito
    while ((match = localBoldRegex.exec(part)) !== null) {
      // Adiciona o texto antes do negrito
      if (match.index > lastIndex) {
        result.push(part.substring(lastIndex, match.index));
      }

      // Adiciona o texto em negrito (sem os asteriscos)
      result.push(<strong key={`bold-${index}-${keyCounter++}`}>{match[1]}</strong>);
      lastIndex = match.index + match[0].length;
    }

    // Adiciona qualquer texto restante após o último negrito
    if (lastIndex < part.length) {
      result.push(part.substring(lastIndex));
    }

    // Se não encontrou nenhum negrito, retorna o texto normal
    if (result.length > 0) {
      return <span key={`text-${index}`}>{result}</span>;
    }
    return part;
  });

  // Para o Dashboard, evitamos retornar arrays de nós para reduzir risco de coerção em string gerando [object Object]
  if (isDashboard) {
    let resultNode: React.ReactNode;
    const allStrings = nodes.every(n => typeof n === 'string');
    if (allStrings) {
      resultNode = (nodes as string[]).join('');
    } else {
      resultNode = <span>{nodes}</span>;
    }

    if (tipo === 'reaction') {
      const prefix = remetenteTipo === 'cliente' ? 'Reagiu com: ' : 'Você reagiu com: ';
      return <span>{prefix}{resultNode}</span>;
    }

    return resultNode;
  }

  return nodes;
};